<template>
    <div class="equivalent-clearcut-area report-wrap">
        <report
            v-if="reportData !== null"
            id="equivalent-clearcut-area-report"
            class="equivalent-clearcut-area web report"
            title="Equivalent Clearcut Area Report"
            :subtitle="watershedInfo.name"
            :report-data="reportData"
            :sections="sections"
        />
    </div>
</template>

<script>
import Report from '@foundryspatial/report';

import EcaChangeSection from '@/components/EquivalentClearcutAreaReport/EcaChangeSection.vue';
import ForestDisturbancesSection from '@/components/EquivalentClearcutAreaReport/ForestDisturbancesSection.vue';
import IntroductionSection from '@/components/EquivalentClearcutAreaReport/IntroductionSection.vue';
import LimitationsSection from '@/components/EquivalentClearcutAreaReport/LimitationsSection.vue';
import MethodsSection from '@/components/EquivalentClearcutAreaReport/MethodsSection.vue';
import OverviewSection from '@/components/EquivalentClearcutAreaReport/OverviewSection.vue';
import PeakFlowSensitiveZoneSection from '@/components/EquivalentClearcutAreaReport/PeakFlowSensitiveZoneSection.vue';
import ReferencesSection from '@/components/EquivalentClearcutAreaReport/ReferencesSection.vue';
import {
    API_ERROR_WATERSHED_DATA,
} from '@/constants/messages.js';

export default {
    name: 'EquivalentClearcutAreaReport',

    components: {
        Report,
    },

    props: {
        // click location as a mapbox.lngLat object
        lngLat: {
            type: Object,
            required: true,
        },

        // selected watershed info
        watershedInfo: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        reportData: null,
        sections: [
            {
                title: 'Overview',
                id: 'overview',
                sectionComponent: OverviewSection,
            },
            {
                title: 'Introduction',
                id: 'introduction',
                sectionComponent: IntroductionSection,
            },
            {
                title: 'Equivalent Clearcut Area Analysis',
                id: 'eca-analysis',
                sectionComponent: EcaChangeSection,
            },
            {
                title: 'ECA in H60 Areas',
                id: 'eca-h60-areas',
                sectionComponent: PeakFlowSensitiveZoneSection,
            },
            {
                title: 'Forest Disturbances',
                id: 'forest-disturbances',
                sectionComponent: ForestDisturbancesSection,
            },
            {
                title: 'Methods',
                id: 'methods',
                sectionComponent: MethodsSection,
            },
            {
                title: 'Limitations',
                id: 'limitations',
                sectionComponent: LimitationsSection,
            },
            {
                title: 'References',
                id: 'references',
                sectionComponent: ReferencesSection,
            },
        ],
    }),

    created() {
        this.getData();
    },

    methods: {
        /**
         * fetch all required report data from the API
         */
        async getData() {
            try {
                const apiResponse = await this.$api.getEcaRollup(this.watershedInfo.wfi);

                this.reportData = {
                    ...apiResponse,
                    // add forest disturbance points to reportData
                    selectedWatershed: this.watershedInfo,
                    lngLat: this.lngLat,
                };

                this.$emit('report-data-available');
            } catch (e) {
                this.$emit('report-data-error');
                this.$handleError(e, API_ERROR_WATERSHED_DATA);
            }
        },
    },
};
</script>

<style lang="scss">
</style>
